
class ImageCustom extends HTMLElement {
  
  connectedCallback() {
    const items = this.querySelectorAll(".step-item");
    const self = this;
  const wrappers = this.querySelectorAll(".section-wrapper__image");
    items.forEach(item => {
      item.addEventListener("click", function() {
        const index = this.getAttribute("data-index");
        items.forEach(el => el.classList.remove("active"));
        wrappers.forEach(el => el.classList.remove("active"));
        this.classList.add("active");
        const target = self.querySelector('.section-wrapper__image[data-index="' + index + '"]');
        if (target) target.classList.add("active");
      });
    });
  }
  
}

if (!customElements.get('custom-image-with-text')) {
  customElements.define('custom-image-with-text', ImageCustom);
}
